var findTextNode = function findTextNode(node) {
  if (node.nodeType === Node.TEXT_NODE && node.textContent && node.textContent.trim().length > 0) {
    return node;
  }
  for (var i = 0; i < node.childNodes.length; i++) {
    var foundNode = findTextNode(node.childNodes[i]);
    if (foundNode) {
      return foundNode;
    }
  }
  return null;
};
export var calculateLineHeightClosestChild = function calculateLineHeightClosestChild(element) {
  var textNode = findTextNode(element);
  if (textNode && textNode.parentElement) {
    var computedStyle = window.getComputedStyle(textNode.parentElement);
    return parseInt(computedStyle.lineHeight, 10);
  }
  return 0;
};